var map = {
	"./App.vue": [
		"3dfd"
	],
	"./components/ComLogin.vue": [
		"455d",
		"chunk-2d0c1206"
	],
	"./components/ComLogout.vue": [
		"d4c8",
		"chunk-2d21e57b"
	],
	"./components/ComQuestions.vue": [
		"5a83",
		"chunk-4a9bab60"
	],
	"./components/ComQuestions2.vue": [
		"9210",
		"chunk-2d0e4bee"
	],
	"./components/footer.vue": [
		"076e",
		"chunk-2d0a482c"
	],
	"./components/lineChart.vue": [
		"26f2",
		"chunk-29537cd2"
	],
	"./components/questionItem.vue": [
		"3d9d",
		"chunk-2d0c4e92"
	],
	"./views/About.vue": [
		"f820",
		"about"
	],
	"./views/exam.vue": [
		"3e57",
		"chunk-29537cd2",
		"chunk-4a9bab60",
		"chunk-05a643e3"
	],
	"./views/index.vue": [
		"1e4b",
		"chunk-4c572b9e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4adc";
module.exports = webpackAsyncContext;